'use client'

import type { PublicSeminarDetailResponse } from '@tebuto/api/public/models/PublicSeminarDetailResponse'
import { SeminarOccurrencesAndBooking as Shared } from '@tebuto/seminars/SeminarOccurrencesAndBooking'
import { useRouter } from 'next/navigation'
import type { JSX } from 'react'
import type { SeminarPageColors } from '../../_shared'

interface SeminarOccurrencesAndBookingProps {
    seminar: PublicSeminarDetailResponse
    therapistSlug: string
    colors: SeminarPageColors
}

export function SeminarOccurrencesAndBooking({
    seminar,
    therapistSlug,
    colors
}: SeminarOccurrencesAndBookingProps): JSX.Element {
    const router = useRouter()
    return (
        <Shared
            seminar={seminar}
            colors={colors}
            allSeminarsHref={seminar.therapistSeminarsPageEnabled ? `/seminare/${therapistSlug}` : undefined}
            onBook={(occurrence) =>
                router.push(`/seminare/${therapistSlug}/${seminar.slug}/anmeldung/${occurrence.publicId}`)
            }
            bottomBarLayout="fixed"
        />
    )
}
